<template>
  <div ref="map" style="border: 0px; height: 100%; width: 100%; min-height: 50em;"></div>

</template>

<script>
import { Map, LngLatBounds } from 'maplibre-gl'
import { api } from '@/main.js'
require('maplibre-gl/dist/maplibre-gl.css')
export default {
  name: 'Map',
  props: ['device', 'timeRange', 'timeCursor'],
  mounted: function () {
    this.map = new Map({
      container: this.$refs['map'],
      style: 'https://static.tcnd.app/map/style_rail.json'
    })
    var dataTrace = {
      'type': 'FeatureCollection',
      'features': [
        {
          'type': 'Feature',
          'geometry': {
            'type': 'LineString',
            'coordinates': []
          }
        }
      ]
    }
    var dataCursor = {
      'type': 'Feature',
      'geometry': {
        'type': 'Point',
        'coordinates': []
      }
    }
    this.map.dragRotate.disable()
    this.map.touchZoomRotate.disableRotation()
    this.map.on('load', () => {
      this.map.addSource('trace', { type: 'geojson', data: dataTrace })
      this.map.addSource('cursor', { type: 'geojson', data: dataCursor })
      this.map.addLayer({
        id: 'trace',
        type: 'line',
        source: 'trace',
        paint: {
          'line-color': '#ff9c00',
          'line-opacity': 1,
          'line-width': 5
        }
      })
      this.map.addLayer({
        id: 'arrow-trace',
        type: 'symbol',
        source: 'trace',
        layout: {
          'symbol-placement': 'line',
          'symbol-spacing': 100,
          'icon-rotate': 45,
          'icon-allow-overlap': true,
          'icon-image': 'rocket-15',
          'icon-size': 1
        }
      })
      this.map.addLayer({
        id: 'cursor',
        type: 'symbol',
        source: 'cursor',
        layout: {
          'symbol-spacing': 100,
          'icon-rotate': 45,
          'icon-image': 'cross-15',
          'icon-size': 2
        }
      })

      this.updateTime()
      this.redraw()
    })
  },
  data: function () {
    return {
      tiles: [],
      zoom: 0,
      tilesRendered: [],
      plot: null,
      map: null,
      data: null
    }
  },
  methods: {
    updateTime: function () {
      // Set the required tiles and zoom level for the current time shown in the plot.
      var start = new Date(this.timeRange[0]).getTime() * 1000
      var end = new Date(this.timeRange[1]).getTime() * 1000
      var diff = end - start
      for (var zoom = 0; zoom < 12; zoom++) {
        if (diff > 2 ** (64 - 4 * zoom)) {
          break
        }
      }
      zoom = zoom - 1
      var t1 = Math.floor(start / 2 ** (64 - 4 * zoom))
      var t2 = t1 + 1
      this.tiles = [t1, t2]
      this.zoom = zoom
    },

    redraw: function () {
      const tileIdent1 = this.device + '/' + 'gnss' + '/' + this.zoom + '/' + this.tiles[0]
      const tileIdent2 = this.device + '/' + 'gnss' + '/' + this.zoom + '/' + this.tiles[1]
      Promise.all([api.get('/data/' + tileIdent1), api.get('/data/' + tileIdent2)])
        .then(response => {
          console.log(response)
          var coordinates = []
          this.data = []
          var start = new Date(this.timeRange[0]).getTime() * 1000
          var end = new Date(this.timeRange[1]).getTime() * 1000
          response.forEach((resp) => {
            console.log(resp)
            resp.data.coordinates.forEach((dataPoint) => {
              if (dataPoint[0] >= start && dataPoint[0] < end) {
                coordinates.push([dataPoint[1], dataPoint[2]])
                this.data.push(dataPoint)
              }
            })
          })
          var data = {
            'type': 'FeatureCollection',
            'features': [
              {
                'type': 'Feature',
                'geometry': {
                  'type': 'LineString',
                  'coordinates': coordinates
                }
              }
            ]
          }
          console.log(coordinates, coordinates.length)

          this.map.getSource('trace').setData(data)

          // Pass the first coordinates in the LineString to `lngLatBounds` &
          // wrap each coordinate pair in `extend` to include them in the bounds
          // result. A variation of this technique could be applied to zooming
          // to the bounds of multiple Points or Polygon geomteries - it just
          // requires wrapping all the coordinates with the extend method.
          var bounds = coordinates.reduce(function (bounds, coord) {
            return bounds.extend(coord)
          }, new LngLatBounds(coordinates[0], coordinates[0]))

          if (coordinates.length > 0) {
            this.map.fitBounds(bounds, { padding: 20 })
          }
        })
    }
  },
  watch: {
    traces: function (val) {
      // 1. setup dummy Traces without data!
      this.updateTraces()
      // update the data in the traces
      this.redraw()
    },
    timeRange: function (val) {
      this.updateTime()
      this.redraw()
    },
    timeCursor: function (val) {
      var d = new Date()
      var off = d.getTimezoneOffset()

      val = val + (off * 60 * 1000000)
      // console.log('timeCursor updated', val, this.data)
      for (var i = 0; i < this.data.length - 1; i++) {
        if (val >= this.data[i][0] && val < this.data[i + 1][0]) {
          var s = (val - this.data[i][0]) / (this.data[i + 1][0] - this.data[i][0])

          var x = this.data[i][1] + (this.data[i + 1][1] - this.data[i][1]) * s
          var y = this.data[i][2] + (this.data[i + 1][2] - this.data[i][2]) * s

          var data = {
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': [x, y]
            }
          }
          this.map.getSource('cursor').setData(data)
          // console.log('updated data on map!')
          break
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
